/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Balance_SettledInputs */

const en_balance_settled = /** @type {(inputs: Balance_SettledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All settled`)
};

const he_balance_settled = /** @type {(inputs: Balance_SettledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הכל סגור`)
};

/**
* | output |
* | --- |
* | "All settled" |
*
* @param {Balance_SettledInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const balance_settled = /** @type {((inputs?: Balance_SettledInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Balance_SettledInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_balance_settled(inputs)
	return he_balance_settled(inputs)
});